if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(onSwymLoadCallback);

function onSwymLoadCallback(swat) {
  setTimeout(function() {
     wishlistCounterUpdate();
  }, 1500)

  // Add listener for the 'addedtowishlist' event to the Swym Event Layer
  window._swat.evtLayer.addEventListener('sw:addedtowishlist', function(params) {
    wishlistCounterUpdate();
  });

  // Add listener for the 'removedfromwishlist' event to the Swym Event Layer
  window._swat.evtLayer.addEventListener('sw:removedfromwishlist', function(params) {
     wishlistCounterUpdate();
  });
}

function wishlistCounterUpdate() {
      let swymAnchor = document.querySelector('#swym-plugin #swym-anchor .swym-anchor-badge'),
          headerWishlistIcon = document.querySelector('.header__icons .swym-wishlist');
  
      if (swymAnchor) {
        let wishlistTotal = swymAnchor.getAttribute('data-count');
        document.querySelector('.swym-wishlist .header__wishlist-count .swym-anchor-badge-header').innerText = wishlistTotal;
        
        if (wishlistTotal > 0) {
            headerWishlistIcon.classList.add('has-item')
        } else {
            headerWishlistIcon.classList.remove('has-item') 
        }
      }
}
